import React, { useEffect } from "react";
import { FullColor } from "../../../layout/FullColor/FullColor";
import { PanelLayout } from "../../../layout/Panel/Panel";
import { Spacing } from "../../../layout/Spacing/Spacing";
import { FlexCenter } from "../../../layout/FlexCenter/FlexCenter";
import IconComponent from "../../../shared/IconComponents/IconComponent";
import { TextCustom } from "../../../ui/TextCustom";
import { FlexBetween } from "../../../layout/FlexBetween/FlexBetween";
import { CloseExec } from "../../../ui/CloseButton";
import {motion} from 'framer-motion';
import { SpacingCustom } from "../../../layout/Spacing/SpacingCustom";
import { RadioBtn } from "../../TreeComposite/TreeSettings/TreeSettingsRadioBtn/RadioBtn";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { rootState } from "../../../../redux/store";
import { GreySections } from "../../Datamanager/Inspector/GreySections";
import { IBasicDetails } from "../../../../interface/interfaces";
import { camelCaseToWords } from "../../../../utils/camelCaseToWord";
import { MinWidth } from "../../../layout/MinWidth/MinWidth";

interface IDashboardFilterWindowProps {
    func: ()=>void,
    openFilter?: boolean

}

export const DashboardFilterWindow:React.FC<IDashboardFilterWindowProps> = ({func, openFilter}) => {
    const dispatch = useAppDispatch()

    const {stagingData} = useAppSelector((state:rootState)=>state.stagingList)

    const countByType = Array.isArray(stagingData)
                        ?
                        stagingData.reduce((acc: Record<string, number>, curr)=>{
                            const type = curr.Type;
                            acc[type] = (acc[type] || 0) + 1
                            return acc
                        },{})
                        :
                        {};
    
    const createArrFromTypeCount = Object.entries(countByType)

    const data = createArrFromTypeCount.map(([type, count], idx) => {
        return (
            <FlexBetween key={idx}>
                <FlexCenter direction="v">
                    <IconComponent size={1.6} iconName={`${camelCaseToWords(type)}`}/>
                    <TextCustom color="grey-dark">{camelCaseToWords(type)}</TextCustom>
                </FlexCenter>
                <TextCustom size={1} color="accent-green" weight={600}>{count}</TextCustom>
            </FlexBetween>
        )
    })
    
    return (
        // <FullColor onTop={true} position="absolute" blur={false}>
        //     </FullColor>
            // <div className={`dashboard-filter-window dashboard-filter-window__${openFilter ? 'open' : 'close'}`}>
            <motion.div
            initial={{ x: "100%" }}
            animate={{ x: openFilter ? "0%" : "100%" }}
            transition={{ duration: 0.1, ease: "easeInOut" }}
            className={`dashboard-filter-window`}>
                    <PanelLayout color="white" borderIntensity={0} hasShadow={true} radius="s">
                        <Spacing paddingSpacing="l" marginSpacing="none">
                            <FlexBetween>
                                <FlexCenter direction="v" position="center">
                                    <IconComponent size={2} iconName="Filter" />
                                    <TextCustom weight={700} size={1.2} color="dark">Filter</TextCustom>
                                </FlexCenter>
                                <CloseExec distanceInPx={10} func={func}/>
                            </FlexBetween>
                                <SpacingCustom paddingTop={3}>
                                    <GreySections title={"Select nodes"} closeSection={false} showTitle hasArrow = {false}>
                                        <SpacingCustom paddingTop={2}>
                                            <FlexCenter gap={.5} position="start" direction="v">
                                                <TextCustom color="dark">There are</TextCustom>
                                                <TextCustom weight={700} color="accent-green">{stagingData.length}</TextCustom>
                                                <TextCustom color="dark">InBox nodes.</TextCustom>
                                            </FlexCenter>
                                            
                                        </SpacingCustom>
                                        <SpacingCustom paddingTop={1}>
                                            <MinWidth width={140}>
                                                <FlexCenter gap={.5}>
                                                    {data}
                                                </FlexCenter>
                                            </MinWidth>
                                        </SpacingCustom>
                                    </GreySections>
                                </SpacingCustom>
                        </Spacing>
                    </PanelLayout>
            </motion.div>
    )
}